<template>
  <div class="layout">
    <el-container style="height: 100vh;">
      <el-aside width="220px" class="layout-aside">
        <div class="logo">
          <img src="../assets/logo.svg" alt="知会云logo" class="logo-img" />
          <span class="logo-text">知会云校园</span>
        </div>
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          router
          background-color="#001529"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <sidebar-item
            v-for="m in (menus || [])"
            :key="m.id || m.path || m.name"
            :item="m"
          />
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="layout-header">
          <div class="header-left">
            <h1 v-if="pageTitle" class="page-title">{{ pageTitle }}</h1>
          </div>
          <div class="right">
            <el-badge
              :value="todoCount"
              :max="99"
              class="todo-badge"
              @click.native="goTodo"
            >
              <i class="el-icon-bell todo-icon"></i>
            </el-badge>
            <el-dropdown>
              <span class="user-dropdown">
                <i class="el-icon-user user-icon"></i>
                <span class="user-name">
                  {{ userInfo && (userInfo.name || userInfo.realName || userInfo.username) }}
                </span>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="goProfile">个人中心</el-dropdown-item>
                <el-dropdown-item divided @click.native="handleLogout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-main class="layout-main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SidebarItem from './SidebarItem.vue';
import { fetchTodoCount } from '@/utils/api';

export default {
  name: 'Layout',
  components: { SidebarItem },
  computed: {
    ...mapGetters('user', ['userInfo', 'menus']),
    pageTitle() {
      const matched = this.$route.matched || [];
      for (let i = matched.length - 1; i >= 0; i -= 1) {
        const title = matched[i].meta && matched[i].meta.title;
        if (title) return title;
      }
      return this.findMenuTitle(this.$route.path, this.menus);
    }
  },
  watch: {
    pageTitle: {
      immediate: true,
      handler(title) {
        document.title = title ? `${title} - 知会云校园` : '知会云校园';
      }
    }
  },
  data() {
    return {
      todoCount: 0
    };
  },
  created() {
    this.loadTodoCount();
  },
  methods: {
    ...mapActions('user', ['logout']),
    async loadTodoCount() {
      const res = await fetchTodoCount();
      if (res && res.code === 0) {
        this.todoCount = res.data || 0;
      }
    },
    goProfile() {
      if (this.$route.path !== '/profile') {
        this.$router.push('/profile').catch(() => {});
      }
    },
    goTodo() {
      if (this.$route.path !== '/todo') {
        this.$router.push('/todo').catch(() => {});
      }
    },
    async handleLogout() {
      await this.logout();
      this.$router.replace('/login');
    },
    findMenuTitle(path, menus) {
      const normalizedPath = path || '';
      for (const menu of menus || []) {
        const menuPath = menu.path
          ? (menu.path.startsWith('/') ? menu.path : `/${menu.path}`)
          : '';
        if (menuPath && menuPath === normalizedPath && menu.name) {
          return menu.name;
        }
        const childTitle = this.findMenuTitle(normalizedPath, menu.children);
        if (childTitle) return childTitle;
      }
      return '';
    }
  }
};
</script>

<style scoped>
.layout-aside {
  background: #001529;
  color: #fff;
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  color: #fff;
  font-weight: bold;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.logo-img {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  margin-right: 8px;
}

.logo-text {
  font-size: 14px;
}

.layout-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.header-left {
  display: flex;
  align-items: center;
  padding-left: 8px;
  min-width: 0;
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.layout-header .right {
  display: flex;
  align-items: center;
}

.user-name {
  margin: 0 8px 0 4px;
}

.layout-main {
  background: #f0f2f5;
}

.user-dropdown {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.user-icon {
  font-size: 18px;
}

.todo-badge {
  margin-right: 16px;
  cursor: pointer;
}

.todo-icon {
  font-size: 18px;
}
</style>

